import React from 'react';
import styles from './XimiXurriButton.module.scss';

const XimiXurriButton = ({ player, onClick }) => {
  return (
    <button
      type="button"
      className={styles.BigRedButton}
      onClick={() => onClick(player)}
    >
      {player}
    </button>
  );
};

export default XimiXurriButton;
